import { useContext } from 'react';
import { SidebarContext, SidebarContextType } from '@/contexts/sidebar/SidebarContext';

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider.");
  }

  return context;
}
